/*
 * @Author: hai.zhang
 * @LastEditors: Gexiaolei gxiaolei@163.com
 * @Date: 2019-08-14 11:38:00
 * @LastEditTime: 2022-06-09 13:41:31
 */
import Vue from '@/app'
import FeCom from 'fe-coms'
import router from './router/index'
import store from './store/index'
import VueLazyload from 'vue-lazyload'
import SyUpload from 'fe-coms/components/basis/sy-upload/upload'
import CurrencyText from 'fe-coms/components/business/multi-currency/currency-text/index.vue'
import { getAuth } from './auth/index.js'
import registerGlobalFilters from '@/common/filter/index.js'
import syImFn from 'fe-coms/components/business/im/index'
import syIm from 'fe-coms/components/business/im/im.vue'
import FilePreview from 'fe-coms/components/business/preview'

// fe-coms sy-editor样式文件引入
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// import Cookies from 'js-cookie'
/* eslint-disable*/
if (process.env.NODE_ENV === 'production') {
  __webpack_public_path__ = window.fe.staticUrl + '/fe-mall/'
} else {
  Vue.config.devtools = true
  window.fe.environment = 'local'
}
// Vue.use(ElementUI)
// Vue.use(VueRouter)
Vue.use(VueLazyload)
Vue.use(FeCom)
Vue.use(syImFn)
Vue.component('syIm', syIm)

// 全局引入filter
registerGlobalFilters(Vue)
Vue.component('sy-upload', SyUpload)
Vue.component('currency-text', CurrencyText)
Vue.component('file-preview', FilePreview)

window.fe.router = router
/* eslint-disable no-new */
getAuth(store, router)
window.vueInstantiation = new Vue({
  router,
  store
}).$mount('#app')
